<template>
  <main class="section">
    
<h3 style="color: violet;">Welcome to: {{ pageURL.title }}</h3>
    <router-link to="/">Back</router-link>

    <p>
    Share the Article's link 
      <code>https://violetdocs.com/#/chats/{{ chatId }}</code>
    </p>
    
      
    <User #user="{ user }">
      <div v-if="user">
        <div class="columns">
          <div class="column">
            <div class="navbar">
              <div class="navbar-item">
                <audio :src="pageURL.mainAudioURL" controls></audio>
              </div>
              <div class="navbar-end">
              <div class="navbar-item">
                <h3 class="title">Page {{ currentPage }}</h3>
              </div>
              <div v-if="!fullScreen" class="navbar-item">
                <img @click="screenToggle" src="../assets/FullScreen.png" alt="FullScreen">
              </div>
              <div v-else class="navbar-item">
                <img @click="screenToggle" src="../assets/NotFullScreen.png" alt="FullScreen">
              </div>
              </div>
            </div>
            
            <Pdf @pageChange="refresh" :pageURL="pageURL" :chatId="chatId" :currentPage.sync="currentPage" :yourId="user.uid" />
                    

          </div>
          <div v-show="!fullScreen" class="column">
            <nav class="planel, fill-height-or-more">
              <div class="panel-heading">
                Metadata 
              </div>
              <div class="panel-tabs"  style="background: violet;">
                <a :class="all" @click="change">All Comments</a>
                <a :class="page" @click="refresh">Page {{ currentPage }} Comments</a>
                <a :class="page">Rankings</a>
                <a :class="page">Announcements</a>
              </div>
              <div>
                <ul class="fill">
                  <li v-for="message of testM" :key="message.id">
                      <ChatMessage :message="message" :owner="user.uid === message.sender" :yourId="user.uid" :currentPage="currentPage" />
                  </li>
                </ul>
              </div>
              

              <div class="columns, panel-block" style="background: violet;">
                <div class="column">
                    
                    <audio v-if="newAudio" :src="newAudioURL" controls></audio>
                    <h5 v-else>Record Audio</h5>

                    <button v-if="!recorder" @click="record()" class="button is-info">Record Voice</button>
                    <button v-else @click="stop()" class="button is-danger">Stop</button>

                    <br />

                    
                </div>

                <div class="column">


                    <input v-model="newMessageText" class="input" />

                    <button
                      :disabled="(!newMessageText && !newAudio) || loading"
                      class="button is-success"
                      type="text"
                      @click="addMessage(user.uid)"
                    >Send</button>
                </div>
              </div>
            </nav>
            
          </div>
        </div>
      </div>
      <Login v-else />
      

    </User>
      
    
  </main>
</template>

<script>

import User from './User.vue';
import ChatMessage from './ChatMessage.vue';
import Login from './Login.vue';
import { db, storage } from '../firebase';
import Pdf from './Pdf.vue';

export default {
  components: {
    User,
    Login,
    ChatMessage,
    Pdf,
  },
  data() {
      return {
          newMessageText: '',
          loading: false,
          messages: [],
          newAudio: null,
          recorder: null,
          pageURL: null,
          currentPage: 1,
          test: [],
          testM: [],
          all: 'is-active',
          page: 'navb',
          numTest: 0,
          comCancel: 'Comment',
          fullScreen: false
      }
  },
  computed: {
    chatId() {
      return this.$route.params.id;
    },
    getPageComments(){
      return db.doc(`chats/${this.chatId}`).collection('messages').where('page', '==', this.currentPage);
    },
    messagesCollection() {
      return db.doc(`chats/${this.chatId}`).collection('messages');
    },
    newAudioURL() {
      return URL.createObjectURL(this.newAudio);
    },
    mainPdfUrl(){
      return db.doc(`chats/${this.chatId}`);
    },
    pageMesseages(){
      return this.messages.filter(message => message.page === this.currentPage)
    }
  },
  firestore() {
    return {
      messages: this.messagesCollection.orderBy('votes', 'desc'),
      pageURL: this.mainPdfUrl,
      test: this.getPageComments,
      testM: this.messagesCollection.orderBy('votes', 'desc')
    };
  },
  methods: {
    screenToggle(){
      if(!this.fullScreen){
        this.fullScreen = true;
      }
      else{
        this.fullScreen = false;
      }
      
    },
    change(){
      this.testM = this.messages;
      this.all = 'is-active';
      this.page = 'navb'
    },
    refresh(){
      this.testM = this.pageMesseages;
      this.all = 'navb';
      this.page = 'is-active'
    },
    async addMessage(uid) {

        this.loading = true;

        let audioURL = null;

        const { id: messageId } = this.messagesCollection.doc();

        if (this.newAudio) {
          const storageRef = storage
            .ref('chats')
            .child(this.chatId)
            .child(`${messageId}.wav`);

            await storageRef.put(this.newAudio);

          audioURL = await storageRef.getDownloadURL();
        }


         await this.messagesCollection.doc(messageId).set({
            text: this.newMessageText,
            sender: uid,
            createdAt: Date.now(),
            audioURL,
            page: this.currentPage,
            messageId: messageId,
            votes: 0
        });

        this.loading = false;
        this.newMessageText = '';
        this.newAudio = null;

        this.refresh();
    },
    async record() {
      this.newAudio = null;

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
      });

      const options = { mimeType: "audio/webm" };
      const recordedChunks = [];
      this.recorder = new MediaRecorder(stream, options);

      this.recorder.addEventListener("dataavailable", e => {
        if (e.data.size > 0) {
          recordedChunks.push(e.data);
        }
      });

      this.recorder.addEventListener("stop", () => {
        this.newAudio = new Blob(recordedChunks);
        console.log(this.newAudio);
      });

      this.recorder.start();
    },
    async stop() {
      this.recorder.stop();
      this.recorder = null;
    },
    // 
    onFileSelected (event){
        this.selectedFile = event.target.files[0]
      },
     async onUpload(){
          const storageRef = storage
            .ref('pdf')
            .child(`${this.selectedFile.name}`);
          await storageRef.put(this.selectedFile)
     }
  }
};
</script>


<style scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #efefef;
  padding: 10px;
  border-radius: 0;
  height: 125vh;
  overflow: auto;
}

li {
  display: flex;
}

.navb{
  color: rgba(0,0,200,0.6);
}

.navb:hover{
      color: white;
    }

.comment {
      font-family: 'Fredoka One';
      letter-spacing: 1px;
      text-transform: uppercase;
      text-align: center;
      border: 2px solid rgba(0,0,200,0.6);
      background: darkviolet;
      color: violet;
      box-shadow: 1px 1px 2px rgba(0,0,200,0.4);
      border-radius: 20px;
      padding: 3px 10px;
      cursor: pointer;
      width: 100%;
    }

  .comment:hover{
    color: white;
  }

button {
      font-family: 'Fredoka One';
      letter-spacing: 1px;
      text-transform: uppercase;
      text-align: center;
      border: 2px solid rgba(0,0,200,0.6);
      background: darkviolet;
      color: violet;
      box-shadow: 1px 1px 2px rgba(0,0,200,0.4);
      border-radius: 20px;
      padding: 3px 10px;
      cursor: pointer;
      width: 100%;
    }
    .title{
      color: rgba(0,0,200,0.6);
    }
    .fill-height-or-more {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .fill-height-or-more > div {
      /* these are the flex items */
      flex: 1;
    }
</style>